/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCloudWatchOutputConfig {
    getFixupPrototypeFunction() { return AwsSsmCloudWatchOutputConfig.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCloudWatchOutputConfig>): AwsSsmCloudWatchOutputConfig {
        let obj = Object.assign(new AwsSsmCloudWatchOutputConfig(), model);
        AwsSsmCloudWatchOutputConfig.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCloudWatchOutputConfig>): AwsSsmCloudWatchOutputConfig {
        if (!model) return null;
        return AwsSsmCloudWatchOutputConfig.newInstance(<AwsSsmCloudWatchOutputConfig> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCloudWatchOutputConfig) {
        if (!obj) return;

        models.AwsSsmCloudWatchOutputConfig.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCloudWatchOutputConfig): boolean {
        Object.setPrototypeOf(obj, AwsSsmCloudWatchOutputConfig.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the log group created to monitor.
     */
    log_group_name: string;

    /**
     * Enabled output keys
     */
    output_enabled: boolean;

}
